module.exports = __webpack_public_path__ + "static/media/ns.67324c1c.svg";